/* unplugin-vue-components disabled */import { render } from "./category-month-danmu.vue?vue&type=template&id=7384891c&scoped=true"
import script from "./category-month-danmu.vue?vue&type=script&lang=js"
export * from "./category-month-danmu.vue?vue&type=script&lang=js"

import "./category-month-danmu.vue?vue&type=style&index=0&id=7384891c&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7384891c"]])

export default __exports__